<template>
  <div class="form-builder assignment module-activity-submission">

    <md-card class="assignment-card">
      <md-card-content>
        <div class="text-left" v-html="submissionText"></div>
        <div class="text-left" v-bind:key="index" v-for="(val, index) in links">
          <component
            :data-props="val"
            :no-delete="true"
            :clean-error="cleanError"
            upload-url="/jsonapi/assignment_submission/assignment_submission/attached_file"
            :is="val.type == 'link' ? 'FbFileViewLink' : 'FbFileViewFile'"
          />
        </div>
        <div class="text-left" v-bind:key="index" v-for="(val, index) in videos">
          <component
            :data-props="val"
            :no-delete="true"
            :clean-error="cleanError"
            upload-url="/jsonapi/assignment_submission/assignment_submission/attached_file"
            :is="'FbVideoViewFile'"
            :sid="uuid"
          />
        </div>
        <div class="text-left feedback">
          <label>Add Feedback:</label>
          <fb-rich-text
            v-model="feedback"
            :uuid="$uuid.v1()"
            :mode="true"
            :element="{ data: { value: feedback } }"
            editor_format="client_full_html"
          />
        </div>
        <div class="text-left">
          <md-checkbox v-model="completed">Mark as complete</md-checkbox>
        </div>
      </md-card-content>
    </md-card>
    <div v-if="showSuccessMessage" class="no-line justify-content-center">
      <div class="success-message">Feedback submitted successfully!</div>
    </div>
    <div class="md-layout-item md-layout md-alignment-center-center">
      <md-button
        class="md-primary md-feedback icon-right fb-submit-btn right"
        @click="sendAssignmentFeedback"
      >
        Submit Feedback
        <md-icon>send</md-icon>
      </md-button>
    </div>

    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import HelpersMixin from "./HelpersMixin";
import Spinner from "./components/Spinner.vue";
import FbFileView from "./components/Form/FbFile/FbFileView";
import FbFileViewFile from "./components/Form/FbFile/FbFileViewFile.vue";
import FbFileViewLink from "./components/Form/FbFile/FbFileViewLink.vue";
import FbVideoViewFile from "./components/Form/FbVideo/FbVideoViewFile.vue";

export default {
  name: "Temporary",
  props: ["mode", "nid", "sid", "noTemplate", "editMode"],
  mixins: [HelpersMixin],
  data() {
    return {
      status:
        window.drupalSettings.assignment_submission.status || "Review Needed",
      feedback: window.drupalSettings.assignment_submission.feedback || "",
      completed:
        !!+window.drupalSettings.assignment_submission.completed || false,
      created: window.drupalSettings.assignment_submission.created || null,
      changed: window.drupalSettings.assignment_submission.changed || null,
      user_info: window.drupalSettings.assignment_submission.user_info || {},
      showSuccessMessage: false,
      uuid: window.drupalSettings.assignment_submission.uuid || null,
      assignment: window.drupalSettings.assignment_submission.assignment || {},
      assignment_submission: window.drupalSettings.assignment_submission || {},
      assignmentLinks:
        window.drupalSettings.assignment_submission.assignment.links || [],
      links: window.drupalSettings.assignment_submission.links || [],
      videos: window.drupalSettings.assignment_submission.videos || [],
      image: null,
      dueDate:
        window.drupalSettings.assignment_submission.assignment.due_date || null,
      title:
        window.drupalSettings.assignment_submission.assignment.title || null,
      description:
        window.drupalSettings.assignment_submission.assignment.description ||
        "",
      coach:
        window.drupalSettings.assignment_submission.assignment.coach.name || "",
      showLoader: false,
      cleanError: false,
      submissionText:
        (window.drupalSettings.assignment_submission.data &&
          window.drupalSettings.assignment_submission.data) ||
        "",
    };
  },
  components: {
    Spinner,
    FbFileView,
    FbFileViewFile,
    FbFileViewLink,
    FbVideoViewFile,
  },
  computed: {
    valid() {
      return this.submissionText != "";
    },
  },
  methods: {
    updateError(value) {
      this.cleanError = value;
    },
    updateLinks(links) {
      this.links = this.links.concat(
        links.map((el) => {
          return {
            link: el,
            type: "link",
          };
        })
      );
    },
    updateFiles(file) {
      this.links = this.links.concat([
        {
          link: file.name,
          type: "file",
          buffer: file.buffer,
          name: file.name,
          uuid: "",
          uri: "",
        },
      ]);
    },
    fileUploaded(index, file) {
      this.links[index].name = file.name;
      this.links[index].uuid = file.uuid;
      this.links[index].uri = file.uri;
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    fileUploadFail(index) {
      this.links.splice(index, 1);
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    },
    del(index) {
      this.links.splice(index, 1);
    },
    sendAssignmentFeedback() {
      this.showLoader = true;
      this.showSuccessMessage = false;
      return this.getToken()
        .then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          let method = "POST";
          let data = {
            feedback: this.feedback,
            completed: this.completed,
          };
          let url =
            "/assignment-submission/" +
            this.assignment_submission.id +
            "/feedback";

          return fetch(url, {
            credentials: "include",
            method: method,
            headers: fetch_headers,
            body: JSON.stringify(data),
          })
            .then((response) => {
              return response.json();
            })
            .then((json) => {
              if (json && json.errors && json.errors.length) {
                throw new Error(json.errors[0].title);
              }
              this.completed = json.completed;
              return json;
            });
        })
        .then(() => {
          this.showLoader = false;
          this.showSuccessMessage = true;
        })
        .catch(() => {
          this.showLoader = false;
        });
    },
  },
};
</script>
<style lang="scss">
.feedback {
  margin-top: 20px;
  .md-field.md-theme-default.md-has-textarea:not(.md-autogrow):after {
    border: 1px solid $blue-dark;
    border-color: $blue-dark;
  }
}
.form-builder .feedback label {
  font-weight: bold;
}
.assignment-desc {
  &.progress-description.progress-description {
    overflow: hidden;
    flex-wrap: wrap;
    min-height: 250px;
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: $blue-dark;
    &::before {
      background-image: url(/assets/img/growth.svg) !important;
      background-size: 261px 261px;
      background-repeat: no-repeat;
      display: block;
      content: "";
      width: 261px;
      height: 261px;
      position: absolute;
      bottom: -6px;
      right: 40px;
      opacity: 1;
      @media all and (max-width: $breakpoint-medium) {
        display: none;
      }
    }
  }
  background-color: $blue-dark !important;
  position: relative;
  background-position: center bottom;
  padding-top: 20px;
  padding-bottom: 10px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
  .assignment-image {
    width: 140px;
    max-width: 140px;
    margin-right: 32px;
    > img {
      transition: $transition;
      transition: var(--transition);
    }
    &:hover {
      > img {
        transform: scale(1.1);
      }
    }
  }
  .assignment-label {
    .label {
      font-family: $font-source-sans-pro;
      font-size: 16px;
      font-weight: bold;
    }
    span {
      font-size: 16px;
      font-weight: normal;
    }
  }
  .assignment-label,
  .assignment-status {
    font-family: $font-source-sans-pro;
    font-size: 16px;
    align-items: center;
    width: 100%;
    color: #ffffff;
    text-align: left;
    .label-text {
      font-size: 20px;
      font-weight: bold;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      height: auto;
      max-height: 85px;
      line-height: 28px;
    }
    .label {
      margin-right: 10px;
    }
  }
  .assignment-status {
    text-align: center;
    display: flex;
    justify-content: center;
    .status {
      display: inline-block;
      background-color: rgba(255, 255, 255, 0.1);
      padding: 10px;
      border-radius: 10px;
    }
  }
}
.md-feedback {
  margin-top: 24px !important;
}
.success-message {
  display: inline-block;
  padding: 8px 40px 8px 30px;
  color: rgb(10, 90, 39);
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  margin-top: 24px;
  text-align: left;
  font-weight: normal;
  min-height: 40px;
  background-color: rgb(213, 240, 200);
  border-radius: 32px;
  background-image: url("./assets/success.svg");
  background-position: 10px center;
  background-repeat: no-repeat;
  padding-left: 35px;
}
.assignment-card {
  a {
    font-weight: normal;
  }
}
</style>
